<template>
  <div class="footer-hello">
    <div class="footer-wrap">
      <div class="footer-hello-c">
        <p>&#169;版权所有：信用中国（甘肃） | 网站声明 | 关于我们</p>
        <p>主办单位：甘肃省社会信用体系建设领导小组办公室 | 承办单位：甘肃省经济研究院 | 技术支持：甘肃省经济研究院 | 联系方式：0931-8800213</p>
        <p>网站标识码：6200000106 | 陇ICP备2024010619号-1 | <img src="../assets/img/beian.png" alt=""> 甘公网安备62010202004394号</p>
      </div>
      <div>
        <img src="../assets/img/dzjg1.png" alt="">
        <img src="../assets/img/dzjg2.png" alt="">
        <img src="../assets/img/dzjg3.png" alt="">
      </div>
    </div>

  </div>
</template>

<script>

export default {

}
</script>

<style scoped lang="scss">
.footer-hello {
  width: 100%;
  background-color: #fff;
  height: 118px;
  position: absolute;
  bottom: 0;
  left: 0;

  box-sizing: border-box;

  .footer-wrap {
    width: 1220px;
    height: 118px;
    display: flex;
    align-items: center;
      margin: auto; 
    >div:nth-child(2) {
      display: flex;
      align-items: center;
      >img:nth-child(1) {
        width: 75px;
        height: 75px;
      }

      >img:nth-child(2) {
        width: 103px;
        height: 52px;
      }

      >img:nth-child(3) {
        width: 106px;
        height: 52px;
      }
    }
  }

  .footer-hello-c { 
    p {
      font-size: 14px;
      color: #333;
      text-align: center;
      margin-bottom: 14px;
      box-sizing: border-box;
    }

    >p:nth-child(3) {
      margin-bottom: 0;
    }
  }
}
</style>
